(function () {
  function listenHeader() {
    var button = document.getElementById('freeuse-btn')
    button.addEventListener('click', function () {
      window.location.href='#retention-darkanchor'
    })
    button.addEventListener('touchstart',function() {
      smoothjump(document.getElementById('retention-darkanchor'))
    })
  }
  listenHeader()
})()